import { render, staticRenderFns } from "./SelectionCourse.vue?vue&type=template&id=deb9009e&scoped=true"
import script from "./SelectionCourse.vue?vue&type=script&lang=js"
export * from "./SelectionCourse.vue?vue&type=script&lang=js"
import style0 from "./SelectionCourse.vue?vue&type=style&index=0&id=deb9009e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb9009e",
  null
  
)

export default component.exports